/**
 * Adzuki.TripSummaryError (TS-415)
 *
 * One place that turns a failed Trip Summary request into a sentence an advisor
 * can act on. The call sites used to print `Error <doing something>: ${…}`,
 * which had two problems:
 *
 * - awaiting a failed Adzuki.Ajax call rejects with the jqXHR, not an Error, so
 *   `error.message` was undefined and the toast read "...: undefined";
 * - a status code or a jQuery status word told the advisor nothing about what
 *   to do next.
 *
 * A string is a message the server chose (`response.error`) and is shown as it
 * is. Anything else is classified by what actually went wrong.
 */
(function TripSummaryError($, Adzuki)
{
	'use strict';

	const tripSummaryError = {};

	// server messages are not consistently punctuated
	function sentence(text) {
		const trimmed = text.trim();

		return (/[.!?]$/).test(trimmed) ? trimmed : `${trimmed}.`;
	}

	function reasonFor(error) {
		if (typeof error === 'string' && error.trim() !== '') {
			return sentence(error);
		}

		// a jqXHR: has a numeric status and statusText
		if (error && typeof error.status === 'number') {
			if (error.statusText === 'timeout') {
				return 'The server took too long to answer. Please try again.';
			}

			if (error.status === 0) {
				return 'We could not reach the server. Check your internet connection and try again.';
			}

			if (error.status === 401 || error.status === 403) {
				return 'Your session may have ended, or you do not have access to this. Reload the page and sign in again.';
			}

			if (error.status === 404) {
				return 'It may have been deleted. Reload the page to see the current version.';
			}

			if (error.status === 413) {
				return 'The file is too large to upload.';
			}

			if (error.status >= 500) {
				return 'Something went wrong on our side. Please try again in a minute, and contact support if it keeps happening.';
			}
		}

		if (error && typeof error.message === 'string' && error.message.trim() !== '') {
			return sentence(error.message);
		}

		return 'Please try again. If it keeps happening, reload the page.';
	}

	/**
	 * @param {*}      error  a server message string, a jqXHR, or an Error
	 * @param {string} action what was being attempted, as a verb phrase:
	 *                        'save the attachment order'
	 * @return {string} "We couldn't save the attachment order. <reason>"
	 */
	tripSummaryError.describe = function describe(error, action) {
		const reason = reasonFor(error);

		return action ? `We couldn't ${action}. ${reason}` : reason;
	};

	tripSummaryError.show = function show(error, action) {
		return Adzuki.StatusMessage('error', tripSummaryError.describe(error, action));
	};

	Adzuki.TripSummaryError = tripSummaryError;
}(jQuery, window.Adzuki || {}));
